import type { TOC } from '@ember/component/template-only';

export interface BvFormLayoutItemSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvFormLayoutItemComponent: TOC<BvFormLayoutItemSignature> = <template>
  <div class='bv-form-layout__item' ...attributes>
    {{yield}}
  </div>
</template>;

export default BvFormLayoutItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvFormLayout::Item': typeof BvFormLayoutItemComponent;
    'bv-form-layout/item': typeof BvFormLayoutItemComponent;
  }
}
